import styled, { createGlobalStyle } from 'styled-components';
import { FlexBox, StackPanel, Typography } from '@agilepoint/wat-react-ux';
import { commonStyles } from 'common';
import { DropdownField } from '@agilepoint/wat-react-ux-form-fields';


export const BasicSettingsGlobalStyle = createGlobalStyle`
    .core-app-content-area {
        overflow-y: hidden;
    }
`;

export const FieldWrapper = styled(FlexBox)`
    position: relative;

    .ap-helpicon-wrapper {
        position: absolute;
        right: 0;
    }
`;

export const BasicSettingsWrapper = styled(StackPanel)` 
    ${commonStyles.boldTextLabel};
    padding-right: 10px;
`;

export const StyledDropdownField = styled(DropdownField)`
    .ap-dropdown-field {
        padding: 0px 15px;
    }
`;

export const TextAreaWrapper = styled.div`
    position: relative;
    width: 100%;
`;

export const TextCounter = styled(Typography.Small)`
    position: absolute;
    bottom: 8px;
    right: 10px;
    color: ${(props) => props.theme.mobileAppAccelerator.semanticColors.grayVariant2};
`;
